import {Component} from "react";
import SectionTitle from "../SectionTitle"
import "./Eln.css"
import InfoList from "../InfoList";
import DisplayScreens from "../DisplayScreens";
import React from 'react';
import Fade from 'react-reveal/Fade'
import FancyNavigation from "../ScrollSpyPagination/PaginationNavigation";

class Eln extends Component {
    constructor() {
        super();
        this.state = {
            images: ['./eln/CN_ELN_1.svg', './eln/CN_ELN_1.png', './eln/CN_ELN_2.svg', './eln/CN_ELN_2.png', './eln/image 95.svg', './eln/image 95.png'],
            isRetina: window.devicePixelRatio >= 2
        }
    }

    render() {
        let screen1 = this.state.isRetina ? this.state.images[1] : this.state.images[0];
        let screen2 = this.state.isRetina ? this.state.images[3] : this.state.images[2];
        let screen3 = this.state.isRetina ? this.state.images[5] : this.state.images[4];
        return (
            <div id="box-1" className={"eln"}>
                <FancyNavigation/>
                <SectionTitle title={"Ваш электронный больничный"}/>
                <div className={"eln-blueline-box"}>
                    <Fade right duration={5000}>
                        <div className={"eln-blueline"}></div>
                    </Fade>
                </div>
                <div className={"eln-container"}>
                    <div className={"eln-infolist"}>
                        <InfoList
                            list={["Вся информация о больничном", "Отслеживание статусов", "Скачивание печатной версии листка нетрудоспособности"]}
                            side={"left"}/>
                    </div>
                    <div className={"eln-screenshots"}>
                        <div className={"eln-display-screen1"}>
                            <Fade delay={750}>
                                <DisplayScreens screen={screen1}/>
                            </Fade>
                        </div>
                        <div className={"eln-display-screen2"}>
                            <Fade delay={1500}>
                                <DisplayScreens screen={screen2}/>
                            </Fade>
                        </div>
                    </div>
                </div>
                <div className={"eln-infolist-certificate"}>
                    <Fade bottom delay={500}>
                        <img src={process.env.PUBLIC_URL + screen3}/>
                    </Fade>
                </div>
            </div>
        );
    }
}

export default Eln;